var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClarityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Clarity Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#779bfe",
    cx: 20,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,14 L12,14 C11.448,14 11,13.552 11,13 C11,12.448 11.448,12 12,12 L28,12 C28.552,12 29,12.448 29,13 C29,13.552 28.552,14 28,14 Z M26,20 L14,20 C13.448,20 13,19.552 13,19 C13,18.448 13.448,18 14,18 L26,18 C26.552,18 27,18.448 27,19 C27,19.552 26.552,20 26,20 Z M22,26 L18,26 C17.448,26 17,25.552 17,25 C17,24.448 17.448,24 18,24 L22,24 C22.552,24 23,24.448 23,25 C23,25.552 22.552,26 22,26 Z",
    fill: "#eaf7f6",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClarityIcon);
export default __webpack_public_path__ + "static/media/clarity-icon.eba929e4e6108de25a7d259b370fd43c.svg";
export { ForwardRef as ReactComponent };